import { CreditStatus } from "./Credit";

export enum RefCodeType {
  ALL = 0,
  LATE = 1,
  SPECIFIC = 2,
  SNOOZE = 3,
  RECURRING = 4,
}
export interface RefCode {
  code: string;
}
export interface ReferenceCodesParam {
  type: RefCodeType;
  creditId?: number;
  duration?: number;
  snoozeDetails?: any;
  /**
   * CRL-3241 "Toplu Öde / Tutar gir": user-entered bulk amount carried to
   * checkout. Client-only — never sent to /checkout/pre or /checkout/preview
   * (see formatUrl); the card payment posts it as PaymentType.CUSTOM.
   */
  amount?: number;
  /**
   * CRL-3241: nearest-due allocation of `amount` as shown in the bulk pay
   * modal — the debts it closes plus the partially paid one. Client-only;
   * filters the checkout summary. The backend allocates authoritatively.
   */
  customAllocation?: {
    coveredCreditIds: number[];
    partial?: { creditId: number; amount: number };
  };
}

export interface PreviewSummary {
  amount: number;
  isPaid: boolean;
  paymentPlans: PreviewDebts[];
}

export interface PreviewDebts {
  creditId: number;
  paymentPlanId: number;
  period: number;
  status: CreditStatus;
  amount: number;
  remainingPaymentAmount: number;
  totalRemainingInterestAmount: number;
  totalRemainingLateAmount: number;
  discountedRemainingServiceFee: number;
  applicationId: string;
  createdAt: string;
  totalPaidAmount: number;
  shop: {
    id: string;
    name: string;
    logoUrl: string;
  };
}
